import servicesUtils from "../../../utils/servicesUtils";
import { useMutation } from "react-query";
var useDeleteMeeting = function useDeleteMeeting() {
  return useMutation(["deleteMeeting"], function (meetingId) {
    return servicesUtils.deleteService("/recordings/".concat(meetingId));
  });
};
export default useDeleteMeeting;